
import React, { useState } from "react";
import { motion } from "framer-motion";
import OpportunitiesHeader from "@/components/opportunities/OpportunitiesHeader";
import OpportunitiesFilter from "@/components/opportunities/OpportunitiesFilter";
import OpportunitiesList from "@/components/opportunities/OpportunitiesList";
import OpportunityDialog from "@/components/opportunities/OpportunityDialog";
import { useAuth } from "@/contexts/AuthContext";
import { useOpportunities } from "@/hooks/opportunities";

const Opportunities = () => {
  const { user } = useAuth();
  
  const {
    opportunities,
    loading,
    searchQuery,
    setSearchQuery,
    selectedType,
    setSelectedType,
    isDialogOpen,
    setIsDialogOpen,
    opportunityTypes,
    handleDelete,
    form,
    handleSubmit,
  } = useOpportunities();

  return (
    <motion.div 
      className="flex flex-col min-h-screen bg-gradient-to-br from-background via-background/95 to-primary/5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <main className="flex-grow container mx-auto px-4 py-8">
        <motion.div
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <OpportunitiesHeader />
        </motion.div>
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <OpportunitiesFilter 
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            opportunityTypes={opportunityTypes}
          />
        </motion.div>
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <OpportunitiesList 
            opportunities={opportunities}
            loading={loading}
            onPostOpportunity={() => setIsDialogOpen(true)}
            onDelete={handleDelete}
            currentUser={user}
          />
        </motion.div>
      </main>
      
      <OpportunityDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
      />
    </motion.div>
  );
};

export default Opportunities;
